import { Component, ViewEncapsulation } from '@angular/core';
import { MachineStepBaseComponent } from '../machine-step-base.component';
import { MachineTaskUpsertModel } from '../../upsert-machine-task-wizard.component';
import { RotecFormGroupConfigV2, FormsModuleV2 } from '@schenck/rotec-components';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'ma-machine-documents-step',
  templateUrl: './documents-step.component.html',
  styleUrls: ['./documents-step.component.less'],
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateDirective, FormsModuleV2],
})
export class MachineDocumentsStepComponent extends MachineStepBaseComponent {
  public documentsFields: RotecFormGroupConfigV2<Pick<MachineTaskUpsertModel, 'documentIds'>> = [
    {
      key: 'documentIds',
      type: 'documents-v2',
      props: {
        maximumFileSizeInMb: 30,
        showSearch: true,
        hideFilterButton: true,
      },
    },
  ];
}
